import { createFileRoute } from '@tanstack/react-router'

import AddressPage from '@/views/customer/pages/address.page'

export const Route = createFileRoute('/_layout/customer/address/')({
  component: AddressPage,
})
